import { render, staticRenderFns } from "./videogolawer.vue?vue&type=template&id=1e7b0a34&scoped=true&"
import script from "./videogolawer.vue?vue&type=script&lang=js&"
export * from "./videogolawer.vue?vue&type=script&lang=js&"
import style0 from "./videogolawer.vue?vue&type=style&index=0&id=1e7b0a34&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1e7b0a34",
  null
  
)

export default component.exports